
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13547",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13547",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1179",
  "client-types": "static-1.512",
  "data-fetching-client": "static-1.10136",
  "foundations-components": "static-1.8783",
  "foundations-components-legacy": "static-1.1808",
  "foundations-theming": "static-1.4987",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.95",
  "head-dlb": "static-1.5330",
  "hs-test-utils": "static-1.8536",
  "hub-http-shared-msw-handlers": "static-1.10939",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11984",
  "I18n": "static-7.1714",
  "jasmine-runner": "static-1.6950",
  "marketplace-discovery-studio-lib": "static-1.942",
  "marketplace-storefront-base": "static-1.13610",
  "quartz": "static-1.7692",
  "react-dlb": "static-1.96",
  "react-rhumb": "static-1.17237",
  "reactive-variable-buffer-atom": "static-1.3349",
  "reporting-testing-lib": "static-1.11367",
  "reselect": "static-3.18",
  "settings-ui-lib": "static-1.13026",
  "SharedI18nStrings": "static-1.190",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7884",
  "ui-addon-i18n": "static-1.11643",
  "ui-addon-react-router-dom": "static-1.10023",
  "unified-auth": "static-1.1298",
  "unified-auth-core-lib": "static-1.1580",
  "usage-tracker": "static-1.7820",
  "usage-tracker-core": "static-1.7670",
  "customer-data-property-utils": "static-1.8550",
  "hub-http": "static-1.6703",
  "integrations-lib": "static-1.17479",
  "marketplace-ui-common": "static-1.21066",
  "marketplace-ui-install": "static-1.1052",
  "property-management-iframe": "static-1.14503",
  "quartz-config": "static-1.1470",
  "quartz-core": "static-1.6911",
  "quartz-routing": "static-1.1122",
  "quick-fetch": "static-1.4242",
  "react": "static-7.204",
  "rpc-client-utils": "static-1.5164",
  "ts-schema": "static-1.4406",
  "ui-universal-auth": "static-1.9784",
  "UIComponents": "static-3.8930",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.523",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven": "static-3.6411",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3969",
  "quartz-webpack": "static-1.3916",
  "bend-plugin-quartz-routing": "static-1.770",
  "ai-components-ui-library": "static-1.10063",
  "codemirror": "static-5.108",
  "foundations-assets": "static-1.5386",
  "pulse": "static-1.1147",
  "react-codemirror": "static-1.11140",
  "ui-extensions-preview-lib": "static-1.1021",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5052",
  "floating-ui": "static-1.70",
  "foundations-theming-specialty": "static-1.2703",
  "framer-motion": "static-1.86",
  "hs-story-utils": "static-1.9926",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.110",
  "react-select-plus": "static-1.120",
  "react-utils": "static-2.5676",
  "react-virtualized": "static-2.114",
  "StyleGuideUI": "static-3.520",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3144",
  "ui-fonts": "static-1.1246",
  "ui-images": "static-2.1282",
  "bend-plugin-foundations-theming": "static-1.3470",
  "foundations-theming-base": "static-1.3972",
  "stylex": "static-1.48",
  "HeadJS": "static-2.828",
  "hs-test-utils-bend-plugin": "static-1.3647",
  "msw": "static-1.105",
  "msw-config": "static-1.34",
  "testing-library": "static-1.167",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4803",
  "ui-addon-video-player": "static-1.9121",
  "ai-rendering-library": "static-1.11442",
  "chirp-fetch": "static-1.2402",
  "connections-embed-lib": "static-1.1790",
  "copilot-toolkit": "static-1.12192",
  "feedback-loader": "static-1.30093",
  "laboratory-lib": "static-3.7644",
  "marketplace-embed": "static-1.23241",
  "marketplace-ui-details": "static-1.10961",
  "marketplace-ui-reviews": "static-1.21021",
  "marketplace-ui-tracking": "static-1.15236",
  "sanitize-text": "static-1.8655",
  "usage-tracker-multi": "static-1.6234",
  "usage-tracker-session-replay": "static-1.5506",
  "beacon-keepalive-queue": "static-1.197",
  "quartz-head": "static-1.1357",
  "web-vitals": "static-1.21",
  "apollo-link-hub-http": "static-2.5086",
  "immer": "static-1.107",
  "immerable": "static-1.4640",
  "highcharts": "static-8.117",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2857",
  "reporting-data": "static-1.69434",
  "cssUtils": "static-1.1120",
  "flux-actions": "static-1.383",
  "react-colorpicker": "static-2.10707",
  "react-dnd-compat": "static-1.5108",
  "redux-observable": "static-1.81",
  "ReduxMessenger": "static-2.10868",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7810",
  "icons": "static-2.708",
  "marketplace-ui-apps-core": "static-1.19598",
  "storybook-react": "static-1.46",
  "trellis-story-utils": "static-1.4997",
  "foundations-components-test-utils": "static-1.6266",
  "quartz-i18n": "static-1.1367",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.788",
  "ads-unified-auth-lib": "static-1.2109",
  "ai-mcp-auth-lib": "static-1.45",
  "custom-vendor-connection-lib": "static-1.348",
  "gemini-settings-lib": "static-1.9823",
  "google-sheets-integration-lib": "static-1.1371",
  "microsoft-drive-auth-lib": "static-1.571",
  "slack-ui-library": "static-1.10897",
  "surveymonkey-integration-lib": "static-1.894",
  "fsm": "static-1.4255",
  "customer-data-objects": "static-1.8207",
  "property-translator": "static-1.5878",
  "hs-locale-management": "static-1.413",
  "frontend-preferences-client": "static-1.8419",
  "hs-promise-utils": "static-1.6089",
  "hubspot-apollo-client": "static-1.5380",
  "integrations-error-boundary-lib": "static-1.14894",
  "integrations-tracking-lib": "static-1.6121",
  "native-integrations-shared-strings": "static-1.8260",
  "sanitize": "static-1.4970",
  "superstore": "static-1.5255",
  "ui-shepherd-react": "static-3.10778",
  "ai-settings-ui-library": "static-1.8627",
  "hub-http-janus": "static-1.912",
  "hubspotter-http": "static-1.4986",
  "immutable-less": "static-1.5149",
  "marketplace-ui-client-types": "static-1.18473",
  "nav-meta": "static-1.30852",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18560",
  "ui-product-approvals-common": "static-1.1650",
  "ai-studio-lib": "static-1.12813",
  "hubspot-prosemirror": "static-1.19320",
  "integrations-reconnect-lib": "static-1.763",
  "ui-addon-iframeable": "static-1.9577",
  "ui-addon-integrations-directory-panel": "static-2.8451",
  "ui-product-approvals": "static-1.29755",
  "ui-tool-access": "static-1.10656",
  "inbound-db-properties-service-client": "static-1.4162",
  "property-management-common": "static-1.6791",
  "opentelemetry-fe-types": "static-1.289",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.611",
  "module-federation": "static-1.41",
  "opentelemetry-fe": "static-1.664",
  "quartz-auth": "static-1.1367",
  "quartz-test": "static-1.1367",
  "quartz-tracking": "static-1.1071",
  "trellis-components": "static-1.3163",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.574",
  "HubStyle": "static-2.12291",
  "bender-build-tools": "static-1.3615",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.24009",
  "ContentUtils": "static-1.69528",
  "customer-data-objects-ui-components": "static-1.13533",
  "sassPrefix": "static-1.385",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2047",
  "bend-plugin-pulse": "static-1.650",
  "event-emitter": "static-1.1459",
  "fast-json-patch": "static-1.76",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5927",
  "magpie-types": "static-1.5387",
  "stylex-utils": "static-1.181",
  "trellis-theming": "static-1.1514",
  "avatar-components": "static-1.2986",
  "breeze-engine-core": "static-1.1532",
  "breeze-engine-lib": "static-1.2254",
  "breeze-onboarding-components": "static-1.1108",
  "customer-data-filters-ui": "static-1.41437",
  "customer-data-reference-ui-components": "static-1.13672",
  "data-integrations-breeze": "static-1.373",
  "embedded-academy-lib": "static-1.16071",
  "ExportDialog": "static-6.10871",
  "global-styles-ai-lib": "static-1.537",
  "highlight.js": "static-1.92",
  "markdown-it": "static-1.6",
  "marketplace-embed-ba": "static-1.944",
  "mermaid": "static-1.47",
  "reporting-action-components": "static-1.42451",
  "reporting-snowflake": "static-1.58050",
  "reporting-ui-components": "static-2.66703",
  "reporting-visualizations": "static-1.61508",
  "trial-components-library": "static-1.14422",
  "ui-addon-teams": "static-1.22037",
  "upgrade-components-lib": "static-1.755",
  "navigation-components": "static-1.19215",
  "nest": "static-1.734",
  "simple-logging-lib": "static-1.3549",
  "nudge-client-utils": "static-1.3453",
  "fail-safe": "static-1.447",
  "app-governance-lib": "static-1.2781",
  "developer-experience-shared-components": "static-1.11040",
  "purchase-motions-components": "static-1.6663",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10843",
  "usage-tracker-anonymous": "static-1.6237",
  "usage-tracker-public": "static-1.7631",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3786",
  "persist-promise": "static-1.4204",
  "reference-resolvers": "static-1.8682",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4412",
  "hubspot-apollo-cache": "static-1.839",
  "universal-page-editor-lib": "static-1.3511",
  "final-form": "static-1.85",
  "redux-toolkit": "static-1.84",
  "simple-data-table": "static-1.3858",
  "merchandise-lib": "static-1.288",
  "onboarding-scopes": "static-1.6951",
  "ui-addon-draggable": "static-3.5248",
  "content-assistance-lib": "static-1.8453",
  "content-media-capture": "static-1.5830",
  "customer-data-ui-utilities": "static-1.10329",
  "emoji-mart": "static-3.9",
  "file-manager-components": "static-1.24877",
  "growth-payments-core": "static-1.26543",
  "knowledge-content-types": "static-1.8767",
  "PatternValidationJS": "static-1.3380",
  "payment-link-components": "static-1.24502",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20589",
  "ui-addon-emoji-picker": "static-1.10362",
  "ui-business-units-lib": "static-1.9595",
  "video-components-external": "static-1.12486",
  "video-data-lib": "static-1.36144",
  "navigation-messaging": "static-1.8542",
  "collaboration-sidebar": "static-1.59105",
  "trellis-ext-dnd": "static-1.577",
  "crm-component-utils": "static-1.40248",
  "crm-properties-common-lib": "static-1.6395",
  "customer-data-properties": "static-1.53123",
  "external-options-client-types": "static-1.4450",
  "hs-resources": "static-1.682",
  "property-value-citations": "static-1.3738",
  "reference-resolvers-lite": "static-1.8611",
  "opentelemetry-web": "static-1.25",
  "hubspotter-http-shared-msw-handlers": "static-1.10937",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "cms-field-types": "static-1.5308",
  "content-icons-ui": "static-1.2479",
  "atom": "static-1.5569",
  "idb-keyval": "static-1.57",
  "reactive-lib": "static-1.1218",
  "trellis-migration-context": "static-1.76",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1232",
  "breeze-artifacts-sdk": "static-1.1062",
  "getting-started-shared-tasks": "static-1.19603",
  "onboarding-journeys-lib": "static-1.1274",
  "conversations-skeleton-state": "static-1.7616",
  "crm-message-bus": "static-1.44152",
  "customer-data-filters-ui-msw-helpers": "static-1.23872",
  "events-data-lib": "static-1.745",
  "FormUrlGenerator": "static-2.5212",
  "framework-builder-read-service-client": "static-1.4347",
  "multi-account-reference-resolvers": "static-1.1510",
  "onboarding-tours": "static-1.17422",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14807",
  "segments-client-types": "static-1.12250",
  "academy-common-lib": "static-1.15532",
  "dashboard-lib": "static-1.83361",
  "hubspot-prosemirror-plugins": "static-1.19312",
  "reporting-plugins": "static-1.11035",
  "share-with-third-party-component-lib": "static-1.9209",
  "ui-asset-management-lib": "static-1.11600",
  "user-context": "static-1.5552",
  "reporting-reports": "static-1.69110",
  "hubs-service-types": "static-1.1765",
  "purchase-motions-api": "static-1.6666",
  "salesImages": "static-1.755",
  "signup-constants": "static-1.19983",
  "nudge-custom-function-registry": "static-1.3210",
  "nudge-renderer-utils": "static-1.3529",
  "whisper-core-api": "static-1.7674",
  "bend-plugin-fail-safe": "static-1.398",
  "framework-listing-lib": "static-2.29856",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31791",
  "apps-service-types": "static-1.4107",
  "oauth-service-types": "static-1.4634",
  "signup-ui-url-generator": "static-2.8535",
  "onboarding-tours-client": "static-1.5637",
  "one-click-checkout": "static-1.776",
  "platform-infra-nav-components": "static-1.8013",
  "subscription-experience-data-types": "static-1.15468",
  "crm-record-cards-client": "static-1.100",
  "crm-record-cards-service-types": "static-1.3873",
  "framework-data-schema-resolvers": "static-1.7391",
  "location-customization-utils-lib": "static-1.10463",
  "redux-thunk": "static-2.86",
  "react-flip-move": "static-1.85",
  "ui-coaching-tips": "static-1.29606",
  "content-media-composition-data-lib": "static-1.13634",
  "fix-webm-duration": "static-1.36",
  "notification-sounds": "static-1.4927",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3975",
  "seat-types-lib": "static-1.1085",
  "ui-addon-opt": "static-4.8915",
  "commerce-tours-lib": "static-1.6894",
  "growth-onboarding-reliability": "static-1.5581",
  "sales-checkout-service-client": "static-1.4019",
  "data-token-picker": "static-1.17169",
  "FileManagerLib": "static-1.40517",
  "content-media-compositions": "static-2.17641",
  "media-bridge-lib": "static-1.19675",
  "chatspot-widget-iframe": "static-1.24000",
  "collaboration-sidebar-common": "static-1.3902",
  "marketing-platform-lib": "static-1.7404",
  "dnd-kit": "static-1.23",
  "commerce-subscription-lib": "static-1.38095",
  "crm-actions": "static-1.6883",
  "crm-cards-sdk": "static-1.45071",
  "customer-data-properties-shared-msw-handlers": "static-1.10266",
  "customer-data-tracking": "static-1.7370",
  "calling-global-api": "static-1.66265",
  "calling-internal-common": "static-1.31820",
  "calling-lifecycle-internal": "static-1.67647",
  "calling-lifecycle-messages": "static-1.59939",
  "commerce-products-lib": "static-1.10968",
  "conditional-properties-service-client": "static-1.4125",
  "crm-index-visualization-core": "static-1.4787",
  "crm-links": "static-1.6811",
  "crm-pipelines-api-client-types": "static-1.4455",
  "data-agent-utils": "static-1.969",
  "formula-editor": "static-1.15040",
  "google-libphonenumber": "static-1.52",
  "inbounddb-objects-service-types": "static-1.4526",
  "meetings-icalendar-utils-lib": "static-1.1129",
  "multi-currency-client-types": "static-1.4020",
  "object-builder-ui-client": "static-1.50101",
  "pipeline-validation-client-types": "static-1.4295",
  "react-tinymce": "static-1.56309",
  "smart-data-capture-core": "static-1.529",
  "tiered-pricing": "static-1.2320",
  "tinymce-config": "static-2.55435",
  "tinymce-plugins": "static-1.58549",
  "tinymce-themes": "static-1.57405",
  "topics-actions-lib": "static-1.682",
  "trellis-ext-i18n": "static-1.1421",
  "ui-addon-form-validation": "static-1.11352",
  "zustand": "static-1.91",
  "fdsr-migration-layer": "static-1.510",
  "restore-request-side-panel-lib": "static-1.2076",
  "growth-data-modal": "static-1.6167",
  "growth-onboarding-confetti": "static-1.3556",
  "growth-onboarding-next-action-utils": "static-1.3024",
  "onboarding-tours-utils": "static-1.1489",
  "ui-shepherd-tracker": "static-1.8159",
  "crm-index-associations-lib": "static-1.6946",
  "academy-service-client": "static-1.4189",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40376",
  "SafeStorage": "static-1.4893",
  "video-embed": "static-1.36978",
  "wootric-nps": "static-1.7309",
  "redux-actions": "static-3.76",
  "EmailSignatureEditor": "static-1.25285",
  "viral-links-lib": "static-1.7581",
  "campaign-roi-lib": "static-1.10881",
  "campaigns-utils-lib": "static-1.3748",
  "ui-addon-calendars": "static-2.5864",
  "nested-table": "static-1.727",
  "timezone-utils": "static-2.5728",
  "getting-started-shared-tasks-store": "static-1.18721",
  "customer-data-views-management": "static-1.26395",
  "framework-data-table": "static-2.12876",
  "nudge-custom-ui-functions": "static-1.1771",
  "switchboard-lib": "static-1.735",
  "access-check-ui-lib": "static-1.1924",
  "app-users-service-client": "static-1.6118",
  "app-users-service-types": "static-1.5526",
  "mini-checkout-client": "static-1.27871",
  "onboarding-utils": "static-1.5872",
  "permissions-shared-i18n-strings-fe": "static-1.2145",
  "ui-coaching-tips-shared-config": "static-1.29591",
  "checkout-sdk": "static-3.24714",
  "payment-method-components": "static-1.7342",
  "touchless-buying-components": "static-1.6582",
  "upgrade-catalog-service-types": "static-1.3902",
  "edison-service-client-types": "static-1.889",
  "framework-data-schema-quick-fetch": "static-1.7296",
  "growth-onboarding-feedback-components": "static-1.7079",
  "audio-components": "static-1.6604",
  "FileManagerImages": "static-1.38028",
  "video-components": "static-1.14488",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20533",
  "commerce-shared-components-lib": "static-1.19616",
  "commerce-tools-ui-lib": "static-1.11360",
  "crm_data": "static-4.93253",
  "crm-activity-creator-data": "static-1.47791",
  "crm-fe-perf": "static-1.23397",
  "universal-record-utils-lib": "static-1.2409",
  "calling-error-reporting": "static-1.31827",
  "shared-worker-versioning": "static-1.11541",
  "calling-usage-tracker": "static-1.7038",
  "voice-sms-access-library": "static-1.2519",
  "commerce-permissions": "static-1.1285",
  "products-iframe-lib": "static-1.8957",
  "products-ui-components-shared-msw-handlers": "static-1.11321",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11022",
  "sales-views-client-types": "static-1.4756",
  "data-agent-kit": "static-1.956",
  "enrichment-settings-lib": "static-1.284",
  "policy-lib": "static-1.7302",
  "bark-lib": "static-1.17032",
  "browser-prettier": "static-1.11",
  "tinymce": "static-5.11",
  "hub-http-contrib": "static-1.3530",
  "interframe": "static-3.5240",
  "tinymce-data": "static-1.41520",
  "ui-addon-sales-email": "static-1.5700",
  "layout-dnd-components": "static-1.13262",
  "layout-dnd-utils": "static-1.12237",
  "ui-brand-identity-lib": "static-1.17001",
  "NamespacedHubStyle": "static-2.9379",
  "onboarding-data-sync-lib": "static-1.2870",
  "growth-onboarding-next-action-components": "static-1.3052",
  "user-context-client": "static-1.5007",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.67",
  "urlinator": "static-1.5011",
  "outpost": "static-1.4628",
  "draft-convert": "static-2.86",
  "draft-extend": "static-3.90",
  "draft-js": "static-5.92",
  "draft-plugins": "static-2.22393",
  "sales-email-signature-service-client": "static-1.4346",
  "copilot-messaging": "static-1.2442",
  "ts-utils-lib": "static-1.649",
  "crm-export-dialog": "static-1.6776",
  "crm-index-ui-shimmer": "static-1.3030",
  "crm-view-components": "static-1.1550",
  "react-beautiful-dnd": "static-1.77",
  "customer-data-associations": "static-1.7836",
  "tasks-actions-lib": "static-1.475",
  "InboxConnectUtils": "static-4.15880",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.886",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4485",
  "company-details-components": "static-1.6704",
  "react-performance-metrics-lib": "static-1.1048",
  "pricing-pages-ui-components": "static-1.16660",
  "quote-checkout-service-types": "static-1.3957",
  "social-insights-client-types": "static-1.22969",
  "utility-belt": "static-1.3035",
  "payments-enrollment-embed-lib": "static-1.24272",
  "stripe-embedded-components": "static-1.8282",
  "customer-data-rte": "static-1.33939",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6570",
  "payments-post-enroll-local-storage-lib": "static-1.5604",
  "qrcode-generator": "static-1.82",
  "quotes-client-types": "static-1.39212",
  "crm_universal": "static-1.22759",
  "customer-data-email": "static-1.18676",
  "meetings-rte-lib": "static-1.578",
  "universal-associations-select": "static-1.11595",
  "crm-object-search-query-utilities": "static-1.10498",
  "calling-orchestration-schema": "static-1.37296",
  "react-reducer-toolkit": "static-1.16707",
  "ContentData": "static-1.69603",
  "layout-data-lib": "static-1.10562",
  "meetings-connect-utils-lib": "static-1.8118",
  "company-details-service-types": "static-1.4442",
  "segments-query-core": "static-1.1928",
  "pricing-pages-api": "static-1.16525",
  "stripe-connect-js": "static-1.85",
  "draft-content-plugins": "static-1.29193",
  "sequences-lib": "static-1.8822",
  "ui-gdpr-components": "static-1.10658",
  "meetings-client-types": "static-1.4088",
  "meetings-core": "static-1.800",
  "advanced-menus-core": "static-1.15852",
  "advanced-menus-lib": "static-1.12596",
  "ui-memberships-settings-lib": "static-1.35240",
  "sequences-client-types-lib": "static-1.8679",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15851",
  "simple-menus-lib": "static-1.17368"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13547",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1179",
  "client-types": "/client-types/static-1.512",
  "data-fetching-client": "/data-fetching-client/static-1.10136",
  "foundations-components": "/foundations-components/static-1.8783",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1808",
  "foundations-theming": "/foundations-theming/static-1.4987",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.95",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-test-utils": "/hs-test-utils/static-1.8536",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10939",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11984",
  "I18n": "/I18n/static-7.1714",
  "jasmine-runner": "/jasmine-runner/static-1.6950",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.942",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13610",
  "quartz": "/quartz/static-1.7692",
  "react-dlb": "/react-dlb/static-1.96",
  "react-rhumb": "/react-rhumb/static-1.17237",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3349",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11367",
  "reselect": "/reselect/static-3.18",
  "settings-ui-lib": "/settings-ui-lib/static-1.13026",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7884",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11643",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10023",
  "unified-auth": "/unified-auth/static-1.1298",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1580",
  "usage-tracker": "/usage-tracker/static-1.7820",
  "usage-tracker-core": "/usage-tracker-core/static-1.7670",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8550",
  "hub-http": "/hub-http/static-1.6703",
  "integrations-lib": "/integrations-lib/static-1.17479",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21066",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1052",
  "property-management-iframe": "/property-management-iframe/static-1.14503",
  "quartz-config": "/quartz-config/static-1.1470",
  "quartz-core": "/quartz-core/static-1.6911",
  "quartz-routing": "/quartz-routing/static-1.1122",
  "quick-fetch": "/quick-fetch/static-1.4242",
  "react": "/react/static-7.204",
  "rpc-client-utils": "/rpc-client-utils/static-1.5164",
  "ts-schema": "/ts-schema/static-1.4406",
  "ui-universal-auth": "/ui-universal-auth/static-1.9784",
  "UIComponents": "/UIComponents/static-3.8930",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.523",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven": "/raven/static-3.6411",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3969",
  "quartz-webpack": "/quartz-webpack/static-1.3916",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.770",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10063",
  "codemirror": "/codemirror/static-5.108",
  "foundations-assets": "/foundations-assets/static-1.5386",
  "pulse": "/pulse/static-1.1147",
  "react-codemirror": "/react-codemirror/static-1.11140",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.1021",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5052",
  "floating-ui": "/floating-ui/static-1.70",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2703",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-story-utils": "/hs-story-utils/static-1.9926",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.110",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-utils": "/react-utils/static-2.5676",
  "react-virtualized": "/react-virtualized/static-2.114",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3144",
  "ui-fonts": "/ui-fonts/static-1.1246",
  "ui-images": "/ui-images/static-2.1282",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3470",
  "foundations-theming-base": "/foundations-theming-base/static-1.3972",
  "stylex": "/stylex/static-1.48",
  "HeadJS": "/HeadJS/static-2.828",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3647",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.34",
  "testing-library": "/testing-library/static-1.167",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4803",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9121",
  "ai-rendering-library": "/ai-rendering-library/static-1.11442",
  "chirp-fetch": "/chirp-fetch/static-1.2402",
  "connections-embed-lib": "/connections-embed-lib/static-1.1790",
  "copilot-toolkit": "/copilot-toolkit/static-1.12192",
  "feedback-loader": "/feedback-loader/static-1.30093",
  "laboratory-lib": "/laboratory-lib/static-3.7644",
  "marketplace-embed": "/marketplace-embed/static-1.23241",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10961",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.21021",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15236",
  "sanitize-text": "/sanitize-text/static-1.8655",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6234",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5506",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.197",
  "quartz-head": "/quartz-head/static-1.1357",
  "web-vitals": "/web-vitals/static-1.21",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5086",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4640",
  "highcharts": "/highcharts/static-8.117",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2857",
  "reporting-data": "/reporting-data/static-1.69434",
  "cssUtils": "/cssUtils/static-1.1120",
  "flux-actions": "/flux-actions/static-1.383",
  "react-colorpicker": "/react-colorpicker/static-2.10707",
  "react-dnd-compat": "/react-dnd-compat/static-1.5108",
  "redux-observable": "/redux-observable/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10868",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7810",
  "icons": "/icons/static-2.708",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19598",
  "storybook-react": "/storybook-react/static-1.46",
  "trellis-story-utils": "/trellis-story-utils/static-1.4997",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6266",
  "quartz-i18n": "/quartz-i18n/static-1.1367",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.788",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.2109",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.45",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.348",
  "gemini-settings-lib": "/gemini-settings-lib/static-1.9823",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1371",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.571",
  "slack-ui-library": "/slack-ui-library/static-1.10897",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.894",
  "fsm": "/fsm/static-1.4255",
  "customer-data-objects": "/customer-data-objects/static-1.8207",
  "property-translator": "/property-translator/static-1.5878",
  "hs-locale-management": "/hs-locale-management/static-1.413",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8419",
  "hs-promise-utils": "/hs-promise-utils/static-1.6089",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5380",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14894",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6121",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8260",
  "sanitize": "/sanitize/static-1.4970",
  "superstore": "/superstore/static-1.5255",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10778",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8627",
  "hub-http-janus": "/hub-http-janus/static-1.912",
  "hubspotter-http": "/hubspotter-http/static-1.4986",
  "immutable-less": "/immutable-less/static-1.5149",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18473",
  "nav-meta": "/nav-meta/static-1.30852",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18560",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1650",
  "ai-studio-lib": "/ai-studio-lib/static-1.12813",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19320",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.763",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9577",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8451",
  "ui-product-approvals": "/ui-product-approvals/static-1.29755",
  "ui-tool-access": "/ui-tool-access/static-1.10656",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4162",
  "property-management-common": "/property-management-common/static-1.6791",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.289",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.611",
  "module-federation": "/module-federation/static-1.41",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.664",
  "quartz-auth": "/quartz-auth/static-1.1367",
  "quartz-test": "/quartz-test/static-1.1367",
  "quartz-tracking": "/quartz-tracking/static-1.1071",
  "trellis-components": "/trellis-components/static-1.3163",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.574",
  "HubStyle": "/HubStyle/static-2.12291",
  "bender-build-tools": "/bender-build-tools/static-1.3615",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.24009",
  "ContentUtils": "/ContentUtils/static-1.69528",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13533",
  "sassPrefix": "/sassPrefix/static-1.385",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2047",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.650",
  "event-emitter": "/event-emitter/static-1.1459",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5927",
  "magpie-types": "/magpie-types/static-1.5387",
  "stylex-utils": "/stylex-utils/static-1.181",
  "trellis-theming": "/trellis-theming/static-1.1514",
  "avatar-components": "/avatar-components/static-1.2986",
  "breeze-engine-core": "/breeze-engine-core/static-1.1532",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2254",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1108",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41437",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13672",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.373",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16071",
  "ExportDialog": "/ExportDialog/static-6.10871",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.537",
  "highlight.js": "/highlight.js/static-1.92",
  "markdown-it": "/markdown-it/static-1.6",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.944",
  "mermaid": "/mermaid/static-1.47",
  "reporting-action-components": "/reporting-action-components/static-1.42451",
  "reporting-snowflake": "/reporting-snowflake/static-1.58050",
  "reporting-ui-components": "/reporting-ui-components/static-2.66703",
  "reporting-visualizations": "/reporting-visualizations/static-1.61508",
  "trial-components-library": "/trial-components-library/static-1.14422",
  "ui-addon-teams": "/ui-addon-teams/static-1.22037",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.755",
  "navigation-components": "/navigation-components/static-1.19215",
  "nest": "/nest/static-1.734",
  "simple-logging-lib": "/simple-logging-lib/static-1.3549",
  "nudge-client-utils": "/nudge-client-utils/static-1.3453",
  "fail-safe": "/fail-safe/static-1.447",
  "app-governance-lib": "/app-governance-lib/static-1.2781",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11040",
  "purchase-motions-components": "/purchase-motions-components/static-1.6663",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10843",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6237",
  "usage-tracker-public": "/usage-tracker-public/static-1.7631",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3786",
  "persist-promise": "/persist-promise/static-1.4204",
  "reference-resolvers": "/reference-resolvers/static-1.8682",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4412",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.839",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3511",
  "final-form": "/final-form/static-1.85",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "simple-data-table": "/simple-data-table/static-1.3858",
  "merchandise-lib": "/merchandise-lib/static-1.288",
  "onboarding-scopes": "/onboarding-scopes/static-1.6951",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5248",
  "content-assistance-lib": "/content-assistance-lib/static-1.8453",
  "content-media-capture": "/content-media-capture/static-1.5830",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10329",
  "emoji-mart": "/emoji-mart/static-3.9",
  "file-manager-components": "/file-manager-components/static-1.24877",
  "growth-payments-core": "/growth-payments-core/static-1.26543",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "PatternValidationJS": "/PatternValidationJS/static-1.3380",
  "payment-link-components": "/payment-link-components/static-1.24502",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20589",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10362",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9595",
  "video-components-external": "/video-components-external/static-1.12486",
  "video-data-lib": "/video-data-lib/static-1.36144",
  "navigation-messaging": "/navigation-messaging/static-1.8542",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59105",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.577",
  "crm-component-utils": "/crm-component-utils/static-1.40248",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6395",
  "customer-data-properties": "/customer-data-properties/static-1.53123",
  "external-options-client-types": "/external-options-client-types/static-1.4450",
  "hs-resources": "/hs-resources/static-1.682",
  "property-value-citations": "/property-value-citations/static-1.3738",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8611",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10937",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "cms-field-types": "/cms-field-types/static-1.5308",
  "content-icons-ui": "/content-icons-ui/static-1.2479",
  "atom": "/atom/static-1.5569",
  "idb-keyval": "/idb-keyval/static-1.57",
  "reactive-lib": "/reactive-lib/static-1.1218",
  "trellis-migration-context": "/trellis-migration-context/static-1.76",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1232",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1062",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19603",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1274",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7616",
  "crm-message-bus": "/crm-message-bus/static-1.44152",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23872",
  "events-data-lib": "/events-data-lib/static-1.745",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5212",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4347",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1510",
  "onboarding-tours": "/onboarding-tours/static-1.17422",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14807",
  "segments-client-types": "/segments-client-types/static-1.12250",
  "academy-common-lib": "/academy-common-lib/static-1.15532",
  "dashboard-lib": "/dashboard-lib/static-1.83361",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19312",
  "reporting-plugins": "/reporting-plugins/static-1.11035",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9209",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11600",
  "user-context": "/user-context/static-1.5552",
  "reporting-reports": "/reporting-reports/static-1.69110",
  "hubs-service-types": "/hubs-service-types/static-1.1765",
  "purchase-motions-api": "/purchase-motions-api/static-1.6666",
  "salesImages": "/salesImages/static-1.755",
  "signup-constants": "/signup-constants/static-1.19983",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3210",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3529",
  "whisper-core-api": "/whisper-core-api/static-1.7674",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.398",
  "framework-listing-lib": "/framework-listing-lib/static-2.29856",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31791",
  "apps-service-types": "/apps-service-types/static-1.4107",
  "oauth-service-types": "/oauth-service-types/static-1.4634",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8535",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5637",
  "one-click-checkout": "/one-click-checkout/static-1.776",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8013",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15468",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.100",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3873",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7391",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10463",
  "redux-thunk": "/redux-thunk/static-2.86",
  "react-flip-move": "/react-flip-move/static-1.85",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29606",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13634",
  "fix-webm-duration": "/fix-webm-duration/static-1.36",
  "notification-sounds": "/notification-sounds/static-1.4927",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3975",
  "seat-types-lib": "/seat-types-lib/static-1.1085",
  "ui-addon-opt": "/ui-addon-opt/static-4.8915",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6894",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5581",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4019",
  "data-token-picker": "/data-token-picker/static-1.17169",
  "FileManagerLib": "/FileManagerLib/static-1.40517",
  "content-media-compositions": "/content-media-compositions/static-2.17641",
  "media-bridge-lib": "/media-bridge-lib/static-1.19675",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.24000",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3902",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7404",
  "dnd-kit": "/dnd-kit/static-1.23",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38095",
  "crm-actions": "/crm-actions/static-1.6883",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45071",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10266",
  "customer-data-tracking": "/customer-data-tracking/static-1.7370",
  "calling-global-api": "/calling-global-api/static-1.66265",
  "calling-internal-common": "/calling-internal-common/static-1.31820",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67647",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59939",
  "commerce-products-lib": "/commerce-products-lib/static-1.10968",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4125",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4787",
  "crm-links": "/crm-links/static-1.6811",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4455",
  "data-agent-utils": "/data-agent-utils/static-1.969",
  "formula-editor": "/formula-editor/static-1.15040",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4526",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1129",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4020",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50101",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4295",
  "react-tinymce": "/react-tinymce/static-1.56309",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.529",
  "tiered-pricing": "/tiered-pricing/static-1.2320",
  "tinymce-config": "/tinymce-config/static-2.55435",
  "tinymce-plugins": "/tinymce-plugins/static-1.58549",
  "tinymce-themes": "/tinymce-themes/static-1.57405",
  "topics-actions-lib": "/topics-actions-lib/static-1.682",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1421",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
  "zustand": "/zustand/static-1.91",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.510",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2076",
  "growth-data-modal": "/growth-data-modal/static-1.6167",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3556",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3024",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1489",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8159",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6946",
  "academy-service-client": "/academy-service-client/static-1.4189",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40376",
  "SafeStorage": "/SafeStorage/static-1.4893",
  "video-embed": "/video-embed/static-1.36978",
  "wootric-nps": "/wootric-nps/static-1.7309",
  "redux-actions": "/redux-actions/static-3.76",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25285",
  "viral-links-lib": "/viral-links-lib/static-1.7581",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10881",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3748",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5864",
  "nested-table": "/nested-table/static-1.727",
  "timezone-utils": "/timezone-utils/static-2.5728",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18721",
  "customer-data-views-management": "/customer-data-views-management/static-1.26395",
  "framework-data-table": "/framework-data-table/static-2.12876",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1771",
  "switchboard-lib": "/switchboard-lib/static-1.735",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1924",
  "app-users-service-client": "/app-users-service-client/static-1.6118",
  "app-users-service-types": "/app-users-service-types/static-1.5526",
  "mini-checkout-client": "/mini-checkout-client/static-1.27871",
  "onboarding-utils": "/onboarding-utils/static-1.5872",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2145",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29591",
  "checkout-sdk": "/checkout-sdk/static-3.24714",
  "payment-method-components": "/payment-method-components/static-1.7342",
  "touchless-buying-components": "/touchless-buying-components/static-1.6582",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3902",
  "edison-service-client-types": "/edison-service-client-types/static-1.889",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7296",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7079",
  "audio-components": "/audio-components/static-1.6604",
  "FileManagerImages": "/FileManagerImages/static-1.38028",
  "video-components": "/video-components/static-1.14488",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20533",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19616",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11360",
  "crm_data": "/crm_data/static-4.93253",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47791",
  "crm-fe-perf": "/crm-fe-perf/static-1.23397",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2409",
  "calling-error-reporting": "/calling-error-reporting/static-1.31827",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11541",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7038",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2519",
  "commerce-permissions": "/commerce-permissions/static-1.1285",
  "products-iframe-lib": "/products-iframe-lib/static-1.8957",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11321",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11022",
  "sales-views-client-types": "/sales-views-client-types/static-1.4756",
  "data-agent-kit": "/data-agent-kit/static-1.956",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.284",
  "policy-lib": "/policy-lib/static-1.7302",
  "bark-lib": "/bark-lib/static-1.17032",
  "browser-prettier": "/browser-prettier/static-1.11",
  "tinymce": "/tinymce/static-5.11",
  "hub-http-contrib": "/hub-http-contrib/static-1.3530",
  "interframe": "/interframe/static-3.5240",
  "tinymce-data": "/tinymce-data/static-1.41520",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5700",
  "layout-dnd-components": "/layout-dnd-components/static-1.13262",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12237",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17001",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9379",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2870",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3052",
  "user-context-client": "/user-context-client/static-1.5007",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.67",
  "urlinator": "/urlinator/static-1.5011",
  "outpost": "/outpost/static-1.4628",
  "draft-convert": "/draft-convert/static-2.86",
  "draft-extend": "/draft-extend/static-3.90",
  "draft-js": "/draft-js/static-5.92",
  "draft-plugins": "/draft-plugins/static-2.22393",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4346",
  "copilot-messaging": "/copilot-messaging/static-1.2442",
  "ts-utils-lib": "/ts-utils-lib/static-1.649",
  "crm-export-dialog": "/crm-export-dialog/static-1.6776",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.3030",
  "crm-view-components": "/crm-view-components/static-1.1550",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.77",
  "customer-data-associations": "/customer-data-associations/static-1.7836",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.475",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15880",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.886",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4485",
  "company-details-components": "/company-details-components/static-1.6704",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1048",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16660",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3957",
  "social-insights-client-types": "/social-insights-client-types/static-1.22969",
  "utility-belt": "/utility-belt/static-1.3035",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24272",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8282",
  "customer-data-rte": "/customer-data-rte/static-1.33939",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6570",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5604",
  "qrcode-generator": "/qrcode-generator/static-1.82",
  "quotes-client-types": "/quotes-client-types/static-1.39212",
  "crm_universal": "/crm_universal/static-1.22759",
  "customer-data-email": "/customer-data-email/static-1.18676",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.578",
  "universal-associations-select": "/universal-associations-select/static-1.11595",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10498",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37296",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16707",
  "ContentData": "/ContentData/static-1.69603",
  "layout-data-lib": "/layout-data-lib/static-1.10562",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8118",
  "company-details-service-types": "/company-details-service-types/static-1.4442",
  "segments-query-core": "/segments-query-core/static-1.1928",
  "pricing-pages-api": "/pricing-pages-api/static-1.16525",
  "stripe-connect-js": "/stripe-connect-js/static-1.85",
  "draft-content-plugins": "/draft-content-plugins/static-1.29193",
  "sequences-lib": "/sequences-lib/static-1.8822",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "meetings-client-types": "/meetings-client-types/static-1.4088",
  "meetings-core": "/meetings-core/static-1.800",
  "advanced-menus-core": "/advanced-menus-core/static-1.15852",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12596",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35240",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8679",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15851",
  "simple-menus-lib": "/simple-menus-lib/static-1.17368"
}
};
